//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';
import _ from 'underscore';

angular
  .module('curalate')
  .filter('nonEmpty', () => (array: unknown[]) => !_(array).isEmpty());
